/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { Icon } from '@uncinc/uncinc-react-kitchen-sink';
import CoreLink from '../CoreLink';
var BreadcrumbsV2 = function BreadcrumbsV2(_ref) {
  var _ref$homeIcon = _ref.homeIcon,
    homeIcon = _ref$homeIcon === void 0 ? 'home' : _ref$homeIcon,
    _ref$showHomeIcon = _ref.showHomeIcon,
    showHomeIcon = _ref$showHomeIcon === void 0 ? true : _ref$showHomeIcon,
    _ref$showHomeLabel = _ref.showHomeLabel,
    showHomeLabel = _ref$showHomeLabel === void 0 ? true : _ref$showHomeLabel,
    _ref$separatorIcon = _ref.separatorIcon,
    separatorIcon = _ref$separatorIcon === void 0 ? 'keyboard_arrow_right' : _ref$separatorIcon,
    _ref$showCurrentPage = _ref.showCurrentPage,
    showCurrentPage = _ref$showCurrentPage === void 0 ? true : _ref$showCurrentPage,
    currentPageTitle = _ref.currentPageTitle,
    _ref$hideOnHighestLev = _ref.hideOnHighestLevel,
    hideOnHighestLevel = _ref$hideOnHighestLev === void 0 ? false : _ref$hideOnHighestLev;
  // When both of these are set to false, you would have no Home crumb.
  // TODO: let TypeScript handle this!
  if (!showHomeIcon && !showHomeLabel) {
    throw new Error('Both showHomeIcon and showHomeLabel cannot be false.');
  }
  var immutableEntity = useSelector(function (state) {
    return state.getIn(['entity']);
  });
  var entity = immutableEntity.toJS();
  var currentImmutableEntity = useSelector(function (state) {
    return state.getIn([entity.entityType === 'taxonomy_term' ? 'taxonomyTerm' : entity.entityType, entity.entityId], null);
  });
  var currentTitle = useMemo(function () {
    var currentEntity = currentImmutableEntity.toJS();

    // If the current page title is manually set, always use that.
    if (currentPageTitle) {
      return currentPageTitle;
    }
    if ('name' in currentEntity) {
      return currentEntity.name[0].value;
    }
    if ('title' in currentEntity) {
      return currentEntity.title[0].value;
    }
    return null;
  }, [currentImmutableEntity, currentPageTitle]);
  var truncatedCurrentTitle = useMemo(function () {
    return currentTitle && currentTitle.replace(/(.{26})(.*)/, '$1...');
  }, [currentTitle]);
  var showCurrentTitle = useMemo(function () {
    return showCurrentPage && truncatedCurrentTitle;
  }, [showCurrentPage, truncatedCurrentTitle]);
  var breadcrumbs = entity.breadcrumbs;

  // On some pages, we don't want to show breadcrumbs if the only page above is Home.
  if (hideOnHighestLevel && breadcrumbs.length === 1) {
    return null;
  }
  return /*#__PURE__*/React.createElement("nav", {
    "aria-label": "Breadcrumb",
    itemType: "https://schema.org/BreadcrumbList",
    className: "Breadcrumbs"
  }, /*#__PURE__*/React.createElement("ol", null, breadcrumbs.map(function (crumb, index) {
    var url = crumb.url,
      title = crumb.title;
    var firstItem = index === 0;
    var lastItem = index === breadcrumbs.length - 1;
    var crumbClasses = classNames('Breadcrumbs__crumb', {
      Breadcrumbs__crumb__home: firstItem
    }, {
      Breadcrumbs__crumb__last: lastItem
    });
    return /*#__PURE__*/React.createElement("li", {
      key: "Breadcrumb__".concat(title),
      itemProp: "itemListElement",
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      className: crumbClasses
    }, /*#__PURE__*/React.createElement(CoreLink, {
      itemProp: "item",
      className: "Breadcrumbs__crumb__link",
      href: url
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "Breadcrumbs__icon Breadcrumbs__icon__previous",
      name: separatorIcon,
      flair: "outlined"
    }), showHomeIcon && firstItem && /*#__PURE__*/React.createElement(Icon, {
      className: "Breadcrumbs__icon Breadcrumbs__icon__home",
      name: homeIcon,
      flair: "outlined"
    }), (showHomeLabel || !firstItem) && /*#__PURE__*/React.createElement("span", {
      itemProp: "name",
      className: "Breadcrumbs__crumb__name"
    }, title)), (!lastItem || showCurrentTitle) && /*#__PURE__*/React.createElement(Icon, {
      className: "Breadcrumbs__icon Breadcrumbs__icon__separator",
      name: separatorIcon,
      flair: "outlined"
    }), /*#__PURE__*/React.createElement("meta", {
      itemProp: "position",
      content: String(index + 1)
    }));
  }), showCurrentTitle && truncatedCurrentTitle && /*#__PURE__*/React.createElement("li", {
    key: "Breadcrumb__".concat(truncatedCurrentTitle),
    itemProp: "itemListElement",
    itemScope: true,
    itemType: "https://schema.org/ListItem",
    className: "Breadcrumbs__crumb__current-page"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-current": "page",
    itemProp: "name",
    className: "Breadcrumbs__crumb__name"
  }, truncatedCurrentTitle), /*#__PURE__*/React.createElement("meta", {
    itemProp: "position",
    content: String(breadcrumbs.length + 1)
  }))));
};
export default BreadcrumbsV2;